import { render, staticRenderFns } from "./FloteInput.vue?vue&type=template&id=490d0998&scoped=true&"
import script from "./FloteInput.vue?vue&type=script&lang=ts&"
export * from "./FloteInput.vue?vue&type=script&lang=ts&"
import style0 from "./FloteInput.vue?vue&type=style&index=0&id=490d0998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d0998",
  null
  
)

export default component.exports